import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * Pre-auth login flows hitting `/logins`. The TIO auth handler still
 * adds `x-api-key`, `Content-Type`, `Time-Zone`, and `X-Request-Id`
 * for every outgoing request, so the legacy adapter's hand-rolled
 * header bundles are dropped here.
 */
const loginsUrl = (path: string) => {
  const opts: QueryUrlOptions = {
    identifier: { type: 'logins' },
    op: 'query',
    resourcePath: 'logins',
  };
  return `${buildBaseURL(opts)}/${path.replace(/^\/+/, '')}`;
};

export function sendForgotPasswordRequest(email: string): RequestInfo {
  return {
    url: loginsUrl('forgot-password'),
    method: 'POST',
    body: JSON.stringify({ email }),
    cacheOptions: { [SkipCache]: true },
  };
}

export function validateResetPasswordTokenRequest(token: string): RequestInfo {
  return {
    url: loginsUrl('validate-reset-token'),
    method: 'POST',
    body: JSON.stringify({ token }),
    cacheOptions: { [SkipCache]: true },
  };
}

export interface ResetPasswordPayload {
  password: string;
  passwordConfirmation: string;
  token: string;
}

export function resetPasswordRequest(payload: ResetPasswordPayload): RequestInfo {
  return {
    url: loginsUrl('reset-password'),
    method: 'POST',
    body: JSON.stringify(payload),
    cacheOptions: { [SkipCache]: true },
  };
}
